export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<rect x="14" y="14" width="4" height="4" rx="2" fill="black"/>
<rect x="14" y="7" width="4" height="4" rx="2" fill="black"/>
<rect x="14" y="21" width="4" height="4" rx="2" fill="black"/>
</svg>
